import React, { FC } from 'react';
import classNames from '../../utils/classnames';
import isMobileAppWebview from '../../utils/is-mobile-app-webview';
import MobileAppSpinner from '../mobile-app-spinner/mobile-app-spinner';
import { SPINNER_SIZES } from './spinner.constants';
import './spinner.scss';

type SpinnerProps = {
    size?: number;
    className?: string;
};

const Spinner: FC<SpinnerProps> = ({ size = SPINNER_SIZES.DEFAULT, className }) => {
    const isMobileWebView = isMobileAppWebview();

    return (
        <div className={classNames('lmp-spinner d-flex align-content-center justify-content-center', className)}>
            {!isMobileWebView && (
                <svg className='ring' height={size} strokeWidth='5' viewBox='25 25 50 50' width={size}>
                    <circle cx='50' cy='50' r='20' />
                </svg>
            )}
            {isMobileWebView && <MobileAppSpinner size={size} />}
        </div>
    );
};

export default Spinner;
